"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var OrderQuestion = function () {
    var _a = (0, react_hook_form_1.useForm)(), handleSubmit = _a.handleSubmit, register = _a.register, setValue = _a.setValue;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_1.useState)([]), questionList = _c[0], setQuestionList = _c[1];
    var _d = (0, react_1.useState)(), orderHashId = _d[0], setOrderHashId = _d[1];
    var _e = (0, react_1.useState)(), isEmpty = _e[0], setIsEmpty = _e[1];
    var _f = (0, react_1.useState)(false), isView = _f[0], setIsView = _f[1];
    var _g = (0, react_1.useState)(), promocodeName = _g[0], setPromocodeName = _g[1];
    var _h = (0, react_1.useState)(), promocodeAmount = _h[0], setPromocodeAmount = _h[1];
    var _j = (0, react_1.useState)(), promocodeDay = _j[0], setPromocodeDay = _j[1];
    var onSubmit = function (data) {
        axios_1.default.post("/app/questions/", data)
            .then(function (response) {
            console.log(response);
            if (response.status == 200) {
                setPromocodeName(response.data.promocode);
                setPromocodeAmount(response.data.value);
                setPromocodeDay(response.data.day);
                setIsView(true);
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    };
    (0, react_1.useEffect)(function () {
        var formNode = document.getElementById("react-question-order");
        var hash = formNode === null || formNode === void 0 ? void 0 : formNode.getAttribute('data-hash-id');
        setValue("hash", hash ? hash : "");
        axios_1.default.get("/app/questions/")
            .then(function (response) {
            if (response.status == 200) {
                setQuestionList(response.data);
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }, []);
    return (react_1.default.createElement(react_1.Fragment, null, !isView
        ?
            react_1.default.createElement("form", { className: "__order-question", onSubmit: handleSubmit(onSubmit) },
                react_1.default.createElement("div", { className: "__order-checkout", style: { gap: "16px" } },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "row",
                            alignContent: "center",
                            alignItems: "center",
                            gap: "24px"
                        } },
                        react_1.default.createElement("div", { className: "__question-caption" },
                            "   ",
                            t("order.status.question")),
                        react_1.default.createElement("div", { className: "__question-caption-promocode " },
                            "   ",
                            t("order.status.question.promocode"))),
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            gap: "16px"
                        } },
                        questionList.map(function (_item) {
                            return react_1.default.createElement("div", { key: _item.id, style: { display: "flex", alignItems: "flex-end", gap: "8px" } },
                                react_1.default.createElement("input", __assign({ type: "radio", id: _item.id.toString() }, register('question'), { value: _item.id })),
                                react_1.default.createElement("label", { htmlFor: _item.id.toString() }, t(_item.question)),
                                _item.flag_custom == true &&
                                    react_1.default.createElement("input", __assign({ placeholder: "input text", type: "text" }, register('custom'))));
                        }),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("button", { type: "submit" },
                                " ",
                                t("order.status.question.sumit"))))))
        :
            react_1.default.createElement(react_1.default.Fragment, null,
                promocodeName &&
                    react_1.default.createElement("div", { className: "question-promocode " },
                        react_1.default.createElement("div", null, t("order.question.promocode")),
                        react_1.default.createElement("div", { className: "promocode-value" }, promocodeName),
                        react_1.default.createElement("img", { style: { cursor: "pointer" }, onClick: function () {
                                if (navigator.clipboard) {
                                    navigator.clipboard.writeText(promocodeName);
                                }
                            }, src: "/images/app/promocode.svg" })),
                promocodeName &&
                    react_1.default.createElement("div", { className: "__wrap-text", style: { border: 0, marginBottom: "150px" } }, t("order.question.promocode.text", { value: promocodeAmount, day: promocodeDay })))));
};
exports.default = OrderQuestion;
